import {useCurrentUser} from '@netx/core-user-next/store/currentUser';
import {PermissionName} from '../constants';
import {currentUserIsAdmin} from './currentUserIsAdmin';
import {legacyPermissionsEnabled} from './legacyPermissionsEnabled';

export {PermissionName} from '../constants';

/**
 * Checks if the current user has access to a specific application permission.
 * @param permission App permission
 * @returns Whether the current user has access to the given permission
 * @note If legacy permissions are active, this will always return `true`.
 */
export const currentUserHasAccess = (permission: PermissionName): boolean => {
	if (legacyPermissionsEnabled()) return true;
	if (permission === PermissionName.VIEW) return true;
	const appPermissions = useCurrentUser.getState().user.appPermissions ?? [];
	return currentUserIsAdmin() || appPermissions.includes(permission);
};
